export default {
  buildCreate(name, email) {
    return {
      'data': {
        'attributes': {
          'name': name,
          'email': email,
        },
        'type': 'agents',
      },
    };
  },
  buildActivationData(password, activationToken) {
    return {
      'password': password,
      'activation_token': activationToken,
    };
  },
  async fetchAllAgents(axios, token) {
    return await axios.get(`/api/business/agents/`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async fetchCurrentAgent(axios, token) {
    return await axios.get(`/api/business/agents/me/`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async createAgent(agentData, axios, token) {
    return await axios.post('/api/business/agents/', agentData, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async activateAgent(data, axios) {
    return await axios.post('/authentication/activate/', data);
  }
};
